/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Console_Prompt_CopiedInputs */

const en_console_prompt_copied = /** @type {(inputs: Console_Prompt_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prompt copied`)
};

const zh_hans1_console_prompt_copied = /** @type {(inputs: Console_Prompt_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`提示词已复制`)
};

const pt_br2_console_prompt_copied = /** @type {(inputs: Console_Prompt_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prompt copiado`)
};

const es_console_prompt_copied = /** @type {(inputs: Console_Prompt_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prompt copiado`)
};

const fr_console_prompt_copied = /** @type {(inputs: Console_Prompt_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prompt copié`)
};

const de_console_prompt_copied = /** @type {(inputs: Console_Prompt_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prompt kopiert`)
};

const ru_console_prompt_copied = /** @type {(inputs: Console_Prompt_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Промпт скопирован`)
};

const it_console_prompt_copied = /** @type {(inputs: Console_Prompt_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prompt copiato`)
};

/**
* | output |
* | --- |
* | "Prompt copied" |
*
* @param {Console_Prompt_CopiedInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const console_prompt_copied = /** @type {((inputs?: Console_Prompt_CopiedInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Console_Prompt_CopiedInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_console_prompt_copied(inputs)
	if (locale === "pt-BR") return pt_br2_console_prompt_copied(inputs)
	if (locale === "es") return es_console_prompt_copied(inputs)
	if (locale === "fr") return fr_console_prompt_copied(inputs)
	if (locale === "de") return de_console_prompt_copied(inputs)
	if (locale === "ru") return ru_console_prompt_copied(inputs)
	if (locale === "it") return it_console_prompt_copied(inputs)
	return en_console_prompt_copied(inputs)
});